import React from "react";
import { Box } from "@mui/material";
import { EditToolButton } from "../../Button/EditToolButton";

interface IListDetailsButtonProps {
    openReadOnly?: boolean
    onClick: () => void;
}

export const ListDetailsButton = (props: IListDetailsButtonProps) => (
    <Box position="absolute" top="1rem" right="0">
        <EditToolButton
            openButton={props.openReadOnly}
            onClick={props.onClick}
        />
    </Box>
);
